import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import { range } from '@/utils'
import { generateAvatar, responsiveDimension } from '../../../utils'
import _, { isEmpty } from 'lodash'
import config from '@/Agent/config'

const Currencies = ['points', 'tokens']
const PlayColors = {
  liveplay: '#c61818',
  gamemaster: '#19d1bf',
  sponsor: '#495bdb',
  prize: '#9368aa',
}

@inject('CommandHostStore', 'PrePlayStore', 'GameStore')
@observer
export default class DDAwards extends Component {
  constructor(props) {
    super(props)
    FONT_SIZE = this.props.CommandHostStore.fontSize + 'vh'
    extendObservable(this, {
      typeItem: null,
      selItem: null,
      points: null,
      tokens: null,
      currencyFixed: '',
      counter2update: 0,
      originalTimerDefault: 1,
    })
    this.defaultGameMaster = {
      firstName: 'G',
      lastName: 'M',
    }
    this.state = {
      _time_limit: {},
      timeLimitOptions: [],
      timerInput: 'unlimited',
      isPregamePlay: false,
      isGameMastersList: false,
      selectedGameMaster: this.defaultGameMaster,
      isGiftQuestion: false,
      isOpinionQuestion: false,
      selectPosition: {
        x: '',
        y: '',
        width: '',
      },
    }

    this.preset = null
    this.has_mult =
      this.props.item.type.toLowerCase().indexOf('liveplay') === 0 ||
      this.props.item.type.toLowerCase().indexOf('gamemaster') === 0
    this.resetInputs()
  }

  resetInputs() {
    this.inputs = {}
    Currencies.forEach(currency => {
      this.inputs[currency] = {}
    })
  }

  initPreset(dontInitPointValue, dontInitTokenValue) {
    this.preset = {}
    if (
      this.props.item &&
      this.props.item.preset &&
      this.props.item.preset.awards &&
      this.props.item.preset.awards
    ) {
      if (this.props.item.preset.awards.points)
        this.preset.points = this.props.item.preset.awards.points
      if (this.props.item.preset.awards.tokens)
        this.preset.tokens = this.props.item.preset.awards.tokens
    }

    if (this.props.GameStore.sportType) {
      const { awards } = this.props.GameStore.sportType
      if (
        this.props.item &&
        awards &&
        awards[(this.props.item.type || '').toLowerCase()]
      ) {
        let filteredAwards = awards[(this.props.item.type || '').toLowerCase()]
        if (filteredAwards && filteredAwards.points && !this.preset.points)
          this.preset.points = filteredAwards.points
        if (filteredAwards && filteredAwards.tokens && !this.preset.tokens)
          this.preset.tokens = filteredAwards.tokens
      }
    }

    if (this.preset) {
      this.resetInputs()
      this.currencyFixed = ''
      let _range

      Currencies.forEach(currency => {
        if (this.preset.hasOwnProperty(currency) && this.preset[currency]) {
          if (
            this.has_mult &&
            this.preset[currency].m &&
            this.preset[currency].m === 'f'
          )
            this.currencyFixed += currency.substring(0, 1).toLowerCase()
          if (
            this.preset[currency].values ||
            (this.preset[currency].range && this.preset[currency].range[1] > 1)
          ) {
            _range = !this.preset[currency].values
              ? range(...this.preset[currency].range)
              : false
            if (_range && _range.length > 11) {
              this.inputs[currency].type = 'input'
              this.inputs[currency].values = this.preset[currency].range
            } else {
              this.inputs[currency].type = 'select'
              this.inputs[currency].values =
                this.preset[currency].values || _range
            }
          }
        }
      })

      if (!dontInitPointValue) {
        this.setValue(
          'points',
          !this.preset.points || this.preset.points.v === undefined
            ? null
            : this.preset.points.v
        )
        if (this.has_mult)
          this.props.value(
            null,
            'points',
            this.currencyFixed.indexOf('p') !== -1
          )
      }

      if (!dontInitTokenValue) {
        this.setValue(
          'tokens',
          !this.preset.tokens || this.preset.tokens.v === undefined
            ? null
            : this.preset.tokens.v
        )
        if (this.has_mult)
          this.props.value(
            null,
            'tokens',
            this.currencyFixed.indexOf('t') !== -1
          )
      }
    }
    if (dontInitPointValue) {
      this.points = this.props.item.points
      if (this.props.item.hasOwnProperty('currencyFixed'))
        this.setCurrencyFixed(
          'points',
          this.props.item.currencyFixed.indexOf('p') !== -1
        )
    }
    if (dontInitTokenValue) {
      this.tokens = this.props.item.tokens
      if (this.props.item.hasOwnProperty('currencyFixed'))
        this.setCurrencyFixed(
          'tokens',
          this.props.item.currencyFixed.indexOf('t') !== -1
        )
    }
  }

  isSet() {
    return [
      !(
        this.props.item.points === undefined || this.props.item.points === null
      ),
      !(
        this.props.item.tokens === undefined || this.props.item.tokens === null
      ),
    ]
  }

  componentDidMount() {
    this.initPreset(...this.isSet())
    this.setTimerInput()
    if (
      this.props.item &&
      this.props.item.pmetadata &&
      this.props.item.pmetadata.public
    ) {
      const publicData = this.props.item.pmetadata.public
      if (publicData.gameMaster)
        this.setState({
          selectedGameMaster: publicData.gameMaster,
        })
      if (publicData.giftQuestion)
        this.setState({
          isGiftQuestion: publicData.giftQuestion,
        })
      if (publicData.opinionQuestion)
        this.setState({
          isOpinionQuestion: publicData.opinionQuestion,
        })
    }

    setTimeout(() => {
      if (
        this.props.item &&
        (this.props.item.type || '').toLowerCase() === 'gamemaster' &&
        !this.state.isGiftQuestion &&
        this.props.item.tokens !== 0
      )
        this.setValue('tokens', 0)
    }, 500)
  }

  componentDidUpdate(prevProps) {
    if (this.props.reinit && !prevProps.reinit) {
      this.initPreset(false, false)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.item) {
      const play = nextProps.item
      this.points = play.points
      this.tokens = play.tokens

      if (play.hasOwnProperty('currencyFixed')) {
        this.currencyFixed = play.currencyFixed || ''
      }

      const metadata = play.pmetadata
        ? typeof play.pmetadata !== 'object'
          ? JSON.parse(play.pmetadata)
          : play.pmetadata
        : {}
      if (
        metadata &&
        metadata.timerInput !== undefined &&
        metadata.timerInput !== this.state.timerInput
      ) {
        this.setState({ timerInput: metadata.timerInput })
      }

      if (metadata && metadata.public) {
        const publicData = metadata.public
        const nextGM = publicData.gameMaster || this.defaultGameMaster
        const nextGift = !!publicData.giftQuestion
        const nextOpinion = !!publicData.opinionQuestion
        if (
          nextGM !== this.state.selectedGameMaster ||
          nextGift !== this.state.isGiftQuestion ||
          nextOpinion !== this.state.isOpinionQuestion
        ) {
          this.setState({
            selectedGameMaster: nextGM,
            isGiftQuestion: nextGift,
            isOpinionQuestion: nextOpinion,
          })
        }
      }
    }
  }

  setTimerInput() {
    if (this.props.item) {
      const isPregamePlay =
        this.props.item.multiplierChoices &&
        this.props.item.multiplierChoices[0]
          ? (this.props.item.multiplierChoices[0].preset || '')
              .toLowerCase()
              .includes('pg')
          : false
      this.setState({ isPregamePlay })
      this.setState({ sourceItem: Object.assign({}, this.props.item) })
      let play = this.props.item
      let { time_limit } = this.props.GameStore.sportType
      const playType =
        (play.type || '').toLowerCase() === 'live'
          ? 'LivePlay'
          : (play.type || '').toLowerCase()
      time_limit = time_limit[playType]
        ? time_limit[playType][isPregamePlay ? 'pregame' : 'live_simulcast'] ||
          null
        : null
      if (time_limit && play) {
        play.pmetadata = play.pmetadata
          ? typeof play.pmetadata !== 'object'
            ? JSON.parse(play.pmetadata)
            : play.pmetadata
          : {}
        let ddOptions = []
        if (time_limit['values']) {
          ddOptions = (time_limit['values'].split(',') || []).map(Number)
          ddOptions.push('unlimited')
        } else if (
          time_limit['range'] &&
          time_limit['range'][0] &&
          time_limit['range'][1]
        ) {
          const min = parseInt(time_limit['range'][0], 10),
            max = parseInt(time_limit['range'][1], 10)
          let i = min
          while (i < max) {
            ddOptions.push(i)
            i = i + parseInt(time_limit.interval, 10)
          }
          ddOptions.push(max)
          ddOptions.push('unlimited')
        }
        this.setState({
          time_limit: time_limit,
          timeLimitOptions: ddOptions,
          timerInput: !isEmpty(play.pmetadata)
            ? play.pmetadata.timerInput || time_limit.default || 'unlimited'
            : time_limit.default || 'unlimited',
        })
      } else {
        this.setState({
          timeLimitOptions: ['unlimited'],
        })
      }
    }
  }

  handleSelectChange(type, e) {
    if (!e.target.value.length) {
      this.forceUpdate()
      return
    }
    this.setValue(type, parseInt(e.target.value))
  }

  handleInputChange(type, e) {
    let v
    if (!e.target.value.length) {
      v = null
    } else {
      v = parseInt(e.target.value)
    }
    const is_num = /^\d+$/.test(e.target.value)

    if (
      v !== null &&
      (!is_num ||
        isNaN(v) ||
        v < this.inputs[type].values[0] ||
        v > this.inputs[type].values[1])
    ) {
      //this.forceUpdate()
      ++this.counter2update
      return
    }
    this.setValue(type, v)
  }

  setCurrencyFixed(currency, val) {
    if (!this.has_mult) return
    const _letter = currency.substring(0, 1).toLowerCase()
    if (val && this.currencyFixed.indexOf(_letter) === -1) {
      this.currencyFixed += _letter
    } else if (!val && this.currencyFixed.indexOf(_letter) !== -1) {
      this.currencyFixed = this.currencyFixed.replace(_letter, '')
    }
  }

  handleMultFixedToggle(currency) {
    if (!this.has_mult) return
    let new_val
    const _letter = currency.substring(0, 1).toLowerCase()
    if (this.currencyFixed.indexOf(_letter) !== -1) {
      this.currencyFixed = this.currencyFixed.replace(_letter, '')
      new_val = false
    } else {
      this.currencyFixed += _letter
      new_val = true
    }
    this.props.value(null, currency, new_val)
  }

  displayMultOrFixed(currency) {
    if (!this.has_mult || (this.preset && !this.preset[currency].m))
      return <span>&nbsp;</span>
    const _letter = currency.substring(0, 1).toLowerCase()
    if (this.preset && this.preset[currency].m === 'o') {
      return (
        <MultFixedSwitch
          onClick={this.handleMultFixedToggle.bind(this, currency)}
          off={this.currencyFixed && this.currencyFixed.indexOf(_letter) !== -1}
          title={`Number of ${currency} is multiplied by Fee Multiplier, or is fixed`}
        >
          x
        </MultFixedSwitch>
      )
    }
    return this.currencyFixed.indexOf(_letter) !== -1 ? (
      <span>&nbsp;</span>
    ) : (
      'x'
    )
  }

  setValue(type, v) {
    this[type] = v
    if (this.props.value && typeof this.props.value === 'function') {
      let _val = {}
      _val[type] = v
      this.props.value(_val)
    }
  }

  displayInputs(type, isDisabled) {
    if (this.inputs[type].type) {
      if (this.inputs[type].type === 'select') {
        return (
          <CurrencySelect
            onChange={this.handleSelectChange.bind(this, type)}
            disabled={isDisabled}
          >
            {this[type] === null ? <option value=""></option> : null}
            {this.inputs[type].values.map(option_value => {
              return (
                <option
                  value={option_value}
                  selected={`${
                    this[type] !== null && option_value == this[type]
                      ? 'selected'
                      : ''
                  }`}
                >
                  {option_value}
                </option>
              )
            })}
          </CurrencySelect>
        )
      } else if (this.inputs[type].type === 'input') {
        return (
          <CurrencyInput
            type="text"
            size="4"
            placeholder={`${this.inputs[type].values[0]}-${this.inputs[type].values[1]}`}
            title={`${this.inputs[type].values[0]} - ${this.inputs[type].values[1]}`}
            defaultValue={`${this[type] === null ? '' : this[type]}`}
            onBlur={this.handleInputChange.bind(this, type)}
          />
        )
      }
    }
    return this[type] === null ? '' : this[type]
  }

  handleGameMastersList(event) {
    this.setState(prevstate => ({
      isGameMastersList: !prevstate.isGameMastersList,
    }))
    const clickedElement = event && event.currentTarget
    const { left, top, width } =
      (clickedElement && clickedElement.getBoundingClientRect()) || {}

    this.setState({
      showDropDown: true,
      selectPosition: {
        x: left,
        y: top,
        width,
      },
    })
  }

  handleSelectedGameMaster(gameMaster) {
    let { selectedGameMaster } = this.state
    if (selectedGameMaster !== gameMaster) {
      selectedGameMaster =
        gameMaster === 'none'
          ? this.defaultGameMaster
          : gameMaster
          ? gameMaster
          : selectedGameMaster
      this.setState({
        selectedGameMaster: selectedGameMaster,
        isGameMastersList: false,
      })
      this.props.value(null, null, null, {
        name: 'gameMaster',
        value: selectedGameMaster,
      })
    }
  }

  async handleOpinionClick() {
    await this.setState(prevstate => ({
      isOpinionQuestion: !prevstate.isOpinionQuestion,
    }))
    this.props.value(null, null, null, {
      name: 'opinionQuestion',
      value: this.state.isOpinionQuestion,
    })
  }

  async handleGiftClick() {
    await this.setState(prevstate => ({
      isGiftQuestion: !prevstate.isGiftQuestion,
    }))
    this.props.value(null, null, null, {
      name: 'giftQuestion',
      value: this.state.isGiftQuestion,
    })
    if (!this.state.isGiftQuestion) this.setValue('tokens', 0)
    else if (this['tokens'] !== this.props.item.tokens || 0) {
      this.setValue('tokens', this.props.item.tokens || 0)
    }
  }

  handleTimeLimitChange(e) {
    if (e && e.target) {
      const timerInput = parseInt(e.target.value || '', 10) || 'unlimited'
      this.setState({ timerInput })
      if (this.props.item) {
        let play = Object.assign({}, this.props.item)
        play.pmetadata = play.pmetadata || {}
        play.pmetadata.timerInput = timerInput
        this.props.handleTimerChange(play)
      }
    }
  }

  render() {
    const bg = PlayColors[this.props.item.type.toLowerCase()]
    const {
      timerInput,
      timeLimitOptions,
      isPregamePlay,
      time_limit,
      isGameMastersList,
      selectedGameMaster,
      isOpinionQuestion,
      isGiftQuestion,
      selectPosition,
    } = this.state
    const { gameMasters } = this.props.GameStore
    const DisplayGameMasters = () => {
      return (
        <GameMastersListWrapper
          onClick={e => {
            e.stopPropagation()
            this.setState({
              isGameMastersList: false,
            })
          }}
        >
          <GameMastersList
            innerRef={c => (this.refGMList = c)}
            style={{
              top: `calc(4.2vh + ${selectPosition.y}px)`,
              left: selectPosition.x,
            }}
          >
            <ListWrapper
              onClick={this.handleSelectedGameMaster.bind(this, 'none')}
            >
              <InitialsAvatar bg={bg}>{'GM'}</InitialsAvatar>
              <TitleWrapper>
                <span>{'NONE'}</span>
              </TitleWrapper>
            </ListWrapper>
            {gameMasters.map((gamemaster, index) => {
              if (gamemaster && selectedGameMaster)
                return (
                  <ListWrapper
                    onClick={this.handleSelectedGameMaster.bind(
                      this,
                      gamemaster
                    )}
                    key={`gamemasterList_${index}`}
                    background={
                      selectedGameMaster.userId === gamemaster.userId ? bg : ''
                    }
                  >
                    {gamemaster.profileimage ? (
                      <AvatarContainer
                        src={
                          config.MEDIA_BASE_URL +
                          'uprofile/thumb/' +
                          gamemaster.profileimage
                        }
                      />
                    ) : (
                      <InitialsAvatar bg={bg}>
                        {generateAvatar(
                          gamemaster.firstName,
                          gamemaster.lastName
                        )}
                      </InitialsAvatar>
                    )}
                    <TitleWrapper>
                      <span style={{ textTransform: 'uppercase' }}>
                        {gamemaster.firstName}&nbsp;
                        {gamemaster.lastName && gamemaster.lastName[0]}.
                      </span>
                    </TitleWrapper>
                  </ListWrapper>
                )
            })}
          </GameMastersList>
        </GameMastersListWrapper>
      )
    }

    const isAGamemasterPlay = (this.props.item.type || '')
      .toLowerCase()
      .includes('gamemaster')

    return (
      <Scrolling bg={bg}>
        <CurrenciesContainer
          height={this.props.height}
          bg={bg}
          key={`currencies-container-${this.props.item.sequence}-${this.counter2update}`}
        >
          <CurrencyContainer height={this.props.height / 2.5}>
            {this.points === null ? <RequiredSpan>* </RequiredSpan> : null}
            {/* <Label isPoints={true}>
              pnts: {this.displayMultOrFixed('points')}{' '}
            </Label> */}
            {this.displayInputs('points')}
          </CurrencyContainer>
          {['gamemaster', 'sponsor', 'prize'].includes(
            (this.props.item.type || '').toLowerCase()
          ) && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: isAGamemasterPlay ? 'column' : 'row',
                justifyContent: isAGamemasterPlay ? 'space-evenly' : 'center',
                height: '100%',
              }}
            >
              {isAGamemasterPlay ? (
                <TextButton
                  name="gift"
                  color={'#fff'}
                  backgroundColor={isGiftQuestion ? '#2EC12F' : '#ffb200'}
                  isDisabled={
                    !(this.props.item.type || '')
                      .toLowerCase()
                      .includes('gamemaster')
                  }
                  width={4}
                  height={2.5}
                  onClick={this.handleGiftClick.bind(this)}
                  pTop={'3%'}
                >
                  {isGiftQuestion ? 'GFT' : 'TKN'}
                </TextButton>
              ) : null}
              <TextButton
                name="opn"
                color={'#000'}
                backgroundColor={isOpinionQuestion ? '#EFDF18' : '#48e0d1'}
                width={4}
                height={2.5}
                onClick={this.handleOpinionClick.bind(this)}
                pTop={'3%'}
              >
                {isOpinionQuestion ? 'OPN' : 'ANS'}
              </TextButton>
            </div>
          )}
          {(this.props.item.type || '').toLowerCase() === 'gamemaster' && (
            <GameMasterInitialContainer>
              <TextButton
                name="gamemasterInitial"
                color={bg}
                backgroundColor={'#000'}
                text={`${
                  selectedGameMaster
                    ? generateAvatar(
                        selectedGameMaster.firstName,
                        selectedGameMaster.lastName
                      )
                    : 'GM'
                }`}
                width={3}
                height={2.5}
                onClick={this.handleGameMastersList.bind(this)}
                pTop={'5%'}
                pLeft={'5%'}
              >
                {selectedGameMaster
                  ? generateAvatar(
                      selectedGameMaster.firstName,
                      selectedGameMaster.lastName
                    )
                  : 'GM'}
              </TextButton>
              {isGameMastersList &&
                gameMasters &&
                ReactDOM.createPortal(<DisplayGameMasters />, document.body)}
            </GameMasterInitialContainer>
          )}
          <CurrencyContainer
            isDisabled={+this.displayInputs('tokens') === 0}
            isTokens={true}
            height={this.props.height / 2.5}
          >
            {this.tokens === null ? <RequiredSpan>* </RequiredSpan> : null}
            {/* <Label>tkns: {this.displayMultOrFixed('tokens')} </Label> */}
            {this.displayInputs('tokens', isAGamemasterPlay && !isGiftQuestion)}
          </CurrencyContainer>
        </CurrenciesContainer>
        {time_limit ? (
          <TimerInputWrapper>
            <TimerSelcetLabel>
              <span>{isPregamePlay ? 'PG' : 'LS'}</span>
              <span>{time_limit['unit']}</span>
            </TimerSelcetLabel>
            <TimerDDContainer height={this.props.height / 2.4}>
              <TimerSelect
                onChange={this.handleTimeLimitChange.bind(this)}
                fontWeight={timerInput === 'unlimited' ? 'bold' : ''}
              >
                {timeLimitOptions.map(option_value => {
                  return option_value === 'unlimited' ? (
                    <option
                      value={option_value}
                      selected={option_value === timerInput}
                    >
                      ∞
                    </option>
                  ) : (
                    <option
                      value={option_value}
                      selected={option_value === timerInput}
                    >
                      {option_value}
                    </option>
                  )
                })}
              </TimerSelect>
            </TimerDDContainer>
          </TimerInputWrapper>
        ) : null}
      </Scrolling>
    )
  }
}

let FONT_SIZE = '1.8vh'

const h = 6

const Label = styled.div`
  width: ${props => (props.isPoints ? '45%' : '43%')};
  display: flex;
  padding-left: ${props => (props.isPoints ? '' : '2px')};
`

const Scrolling = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: ${props => props.bg};
  font-family: pamainregular;
  font-size: ${props => FONT_SIZE};
  letter-spacing: ${props => 0.1}vh;
`

const CurrencySelect = styled.select`
  color: #000;
  font-family: pamainregular;
`

const CurrencyInput = styled.input`
  color: #000;
  height: inherit;
  font-family: pamainregular;
`

const MultFixedSwitch = styled.span`
  cursor: pointer;
  color: #fff;
  text-decoration: underline;
  opacity: ${props => (props.off ? 0.5 : 1)};
  padding: 0 2px;
`

const RequiredSpan = styled.span`
  color: #fff;
`

const CurrenciesContainer = styled.div`
  width: 100%;
  height: ${props => props.height}vh;
  background-color: ${props => props.bg};
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding-left: 3%;
`

const GameMasterInitialContainer = styled.div`
  display: flex;
  margin-right: ${responsiveDimension(1)};
`

const TextButton = styled.div`
  width: ${props => responsiveDimension(props.width || 4)};
  height: ${props => responsiveDimension(props.height || 2.4)};
  color: ${props => props.color || '#fff'};
  background-color: ${props => props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainregular;
  font-size: ${props => responsiveDimension(2)};
  border: ${responsiveDimension(0.2)} solid #000;
  padding-top: ${props => props.pTop || ''};
  padding-left: ${props => props.pLeft || ''};
  margin-right: ${props =>
    props.name !== 'gamemasterInitial' && responsiveDimension(1)};
  opacity: ${props => (props.isDisabled ? 0 : '')};
  pointer-events: ${props => (props.isDisabled ? 'none' : '')};
`

const GameMastersListWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: transparent;
  overflow: auto;
  z-index: 100;
`

const GameMastersList = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 1000 !important;
  position: absolute;
  background-color: #f1f1f1;
  width: ${props => responsiveDimension(18)};
  height: ${responsiveDimension(15)}
  overflow: ${props => 'auto'};
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  margin-top: -${props => 1.8}vh;
  ms-overflow-style: ${'-ms-autohiding-scrollbar'};
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0.3vh rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
    border-radius: ${props => 1}vh;
  }
  &::-webkit-scrollbar {
    width: ${props => responsiveDimension(0.4)};
    background-color: #f5f5f5;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 0, 0, 0.6);
    &:hover {
      background-color: rgba(255, 0, 0, 1);
    }
    border-radius: ${props => 1}vh;
  }
`

const ListWrapper = styled.div`
  display: flex;
  width: 100%;
  height: ${responsiveDimension(5)};
  padding: 3%;
  align-items: center;
  background-color: ${props => props.background || ''};
  &:hover {
    background-color: ${props => '#d3d3d3'};
  }
`

const AvatarContainer = styled.img`
  border-radius: ${props => responsiveDimension(2.7)};
  border: ${props => responsiveDimension(0.2)} solid white;
  width: ${responsiveDimension(4)};
  height: ${responsiveDimension(4)};
`

const InitialsAvatar = styled.div`
  height: ${responsiveDimension(4)};
  width: ${responsiveDimension(4)};
  color: #fff;
  font-size: ${responsiveDimension(2)};
  border-radius: ${responsiveDimension(2.7)};
  border: ${responsiveDimension(0.2)} solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.bg || ''};
`

const TitleWrapper = styled.div`
  display: flex;
  align-items: end;
  width: ${responsiveDimension(8)};
  height: ${responsiveDimension(3)};
  border-bottom: 1px solid #000;
  padding-left: 5%;
  text-transform: uppercase;
`

const CurrencyContainer = styled.div`
  color: #fff;
  width: ${props =>
    props.isTokens ? 'fit-content' : responsiveDimension(5.6)};
  height: ${props => props.height}vh;
  font-size: ${FONT_SIZE};
  display: ${props => (props.isDisabled ? 'none' : 'flex')};
  margin-right: ${props => responsiveDimension(1)};
`

const CountButton = styled.button`
  background-color: transparent;
  border: none;
  width: 100%;
  height: 37.5%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #fff;
  &:hover {
    background-color: #18c5ff;
  }
`

const TimerInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: ${responsiveDimension(1)};
`

const TimerSelcetLabel = styled.div`
  display: flex;
  align-items: end;
  justify-content: center;
  color: #fff;
  font-family: pamainregular;
  margin-left: ${responsiveDimension(0.1)};
  margin-top: ${responsiveDimension(0.9)};

  span:first-child {
    font-size: ${responsiveDimension(1.8)};
    line-height: 0.8;
  }

  span:last-child {
    font-size: ${responsiveDimension(1.5)};
    line-height: 0.8;
  }
`

const TimerDDContainer = styled.div`
  color: #fff;
  width: ${responsiveDimension(4)};
  height: ${props => props.height}vh;
  font-size: ${FONT_SIZE};
  display: ${props => (props.isDisabled ? 'none' : 'flex')};
`

const TimerSelect = styled.select`
  width: 100%;
  color: #000;
  font-family: pamainregular;
  font-weight: ${props => props.fontWeight || ''};
  font-size: ${responsiveDimension(2)};
  border: ${responsiveDimension(0.2)} solid #000;
`



// WEBPACK FOOTER //
// src/Components/CommandHost/Common/DDAwards.js